export default __webpack_public_path__ + "static/media/logo.bb3a3aae.svg";